import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Project } from '../../common/interfaces/project.interface';
import { SelectBy } from '../../common/interfaces/sort-by.interface';
import { Pageable } from '../../common/interfaces/pageable.interface';

@Injectable()
export class CommonProjectService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    create(project: Project): Observable<Project> {
        const body = this.cloneAndRemoveNulls(project);
        return this.http.post(this.getApiUrl() + '/projects', body)
            .pipe(map((res: any) => res || {}));
    }

    findAll(state: string, searchValue?: string, size?: number): Observable<Project[]> {
        const sortBy: SelectBy = {type: 'NAME', order: 'ASCENDING'};
        let params = this.getSortHeaders(sortBy);
        params = params.append('state', state);
        params = params.append('size', size ? size.toString() : '50');
        if (searchValue) {
            params = params.append('freeTextSearch', searchValue);
        }
        return this.http.get(this.getApiUrl() + '/projects/overview', {params})
            .pipe(map((res: any) => res.content || []));
    }

    findAllPageable(page: number, state: string, search?: string, size?: number): Observable<Pageable> {
        const sortBy: SelectBy = {order: 'ASCENDING', type: 'NAME'};
        let params = this.getSortHeaders(sortBy);
        params = params.append('state', state);
        params = params.append('size', size ? size.toString() : '50');
        params = params.append('page', page.toString());
        if (search) {
            params = params.append('freeTextSearch', search);
        }

        return this.http.get(this.getApiUrl() + '/projects/overview', { params })
            .pipe(map((res: Pageable) => res || {content: []}));
    }

    findOne(id: string): Observable<Project> {
        return this.http.get(this.getApiUrl() + '/projects/' + id)
            .pipe(map((res: any) => res || {}));
    }
}
